import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { configureApiClient } from '@access-cms/api-client';

import '@cmsgov/design-system/dist/css/index.css';

import { AlertsProvider } from './hooks/useAlerts';
import { ModalProvider } from './hooks/useModal';
import { router } from './router';
import logger from './utils/logger';
import './index.css';
import { AuthProvider } from './components/auth/AuthContext';
import { ApplicantApplicationAccessProvider } from './hooks/useApplicantApplicationAccess';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 5 * 60 * 1000,
    },
  },
});

configureApiClient({
  baseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:3001',
});

logger.info('Access CMS UI Application starting...');
logger.info(
  {
    buildDate: import.meta.env.VITE_BUILD_DATE,
    environment: import.meta.env.VITE_ENVIRONMENT,
    gitHash: import.meta.env.VITE_GIT_HASH,
    service: import.meta.env.VITE_SERVICE_NAME,
    version: import.meta.env.VITE_VERSION,
  },
  'UI build information',
);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ApplicantApplicationAccessProvider>
          <AlertsProvider>
            <ModalProvider>
              <RouterProvider router={router} />
            </ModalProvider>
          </AlertsProvider>
        </ApplicantApplicationAccessProvider>
      </AuthProvider>
      {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  </StrictMode>,
);

logger.info('Access CMS UI Application rendered successfully');
